/* eslint-disable quotes, comma-dangle */
import "../../styles/EntretenimientoPage.css";
import entretenimientoTitulo from "../../assets/titulos/entretenimiento.png";
import entertainment from "../../assets/titles/entertainment.png";

import cocktel from "../../assets/entretenimiento/cocktel.jpg";
import dj from "../../assets/entretenimiento/dj.jpg";
import game from "../../assets/entretenimiento/game.png";
import hook from "../../assets/entretenimiento/hook.jpg";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import LocalizedTitleImage from "../../components/UseLanguage";
import menuIcon from "../../assets/menu.png";

interface ItemEntretenimiento {
  titulo: string;
  descripcion: string;
  imagen: string;
}

function EntretenimientoPage() {
  const [isFading, setIsFading] = useState(false);
  const { t } = useTranslation();
  const entretenimiento = [
    {
      titulo: t("entretenimiento.party.titulo"),
      descripcion: t("entretenimiento.party.descripcion"),
      imagen: dj,
    },
    {
      titulo: t("entretenimiento.cockteles.titulo"),
      descripcion: t("entretenimiento.cockteles.descripcion"),
      imagen: cocktel,
    },
    {
      titulo: t("entretenimiento.hookas.titulo"),
      descripcion: t("entretenimiento.hookas.descripcion"),
      imagen: hook,
    },
    {
      titulo: t("entretenimiento.juegos.titulo"),
      descripcion: t("entretenimiento.juegos.descripcion"),
      imagen: game,
    },
  ];
  const [activeTab, setActiveTab] = useState<string>(entretenimiento[0].titulo);

  const itemActivo: ItemEntretenimiento | undefined = entretenimiento.find(
    (item) => item.titulo === activeTab
  );

  const cambiarTab = (titulo: string) => {
    if (titulo === activeTab) return;
    setIsFading(true);
    setTimeout(() => {
      setActiveTab(titulo);
      setIsFading(false);
    }, 250);
  };

  return (
    <div className="entretenimiento-pagina fade-tab">
      <div className="menu-icon-div-ent">
        <img src={menuIcon} />
      </div>
      <div className="entretenimiento-title-wrapper">
        <LocalizedTitleImage
          imageEn={entertainment}
          imageEs={entretenimientoTitulo}
          className="entretenimiento-title-img"
        />
      </div>

      {/* Selector visible solo en móvil */}
      <select
        className="entretenimiento-select-movil"
        value={activeTab}
        onChange={(e) => cambiarTab(e.target.value)}
      >
        {entretenimiento.map((item) => (
          <option key={item.titulo} value={item.titulo}>
            {item.titulo}
          </option>
        ))}
      </select>

      <div className="entretenimiento-layout">
        {/* Sidebar visible solo en desktop */}
        <div className="entretenimiento-sidebare">
          {entretenimiento.map((item) => (
            <div
              key={item.titulo}
              className={`sidebare-item ${
                item.titulo === activeTab ? "activo" : ""
              }`}
              onClick={() => cambiarTab(item.titulo)}
            >
              {item.titulo}
            </div>
          ))}
        </div>

        {/* Contenido principal */}
        <div
          className={`entretenimiento-contenido ${
            isFading ? "fade-out" : "fade-in"
          }`}
        >
          <div className="entretenimiento-info-fila">
            <div className="entretenimiento-img-box">
              <img
                src={itemActivo?.imagen}
                alt={itemActivo?.titulo}
                className="imagen-principal"
              />
            </div>
            <div className="entretenimiento-texto-box">
              <p>{itemActivo?.descripcion}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EntretenimientoPage;
